import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { MaskHeading, Reveal } from "@/components/site/Reveal";
import { usePageMeta } from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("Page not found", "The page you were looking for could not be found.");
  return (
    <section className="flex min-h-[80vh] items-center pt-32 pb-24" data-testid="not-found-page">
      <div className="container-x">
        <p className="eyebrow">Error 404</p>
        <MaskHeading as="h1" onLoad lines={["This page has", <em key="i" className="italic font-light text-rose-ink">moved shelves.</em>]} className="font-display mt-6 text-5xl leading-[1.02] tracking-tight sm:text-7xl" />
        <Reveal delay={0.4}>
          <p className="mt-8 max-w-md text-lg text-[var(--ink-2)]">The page you were looking for doesn't exist or may have been moved.</p>
          <div className="mt-10 flex flex-wrap gap-4">
            <Link to="/" className="btn-ink" data-testid="notfound-home-btn">Back to Home <ArrowUpRight size={18} /></Link>
            <Link to="/brands" className="btn-line" data-testid="notfound-brands-btn">Our Brands</Link>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
